/* global localData */
// **************************************************
// Scroll to top
// **************************************************

const topButtons = document.querySelectorAll('.tab-module__scroll-top');
if (topButtons) {
  topButtons.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.scrollIntoView({ behavior: 'smooth' }, true);
    });
  });
}

// **************************************************
// Redirect to parent page if not active check every second
// **************************************************
try {
  if (typeof localData.parent !== 'undefined') {
    let time = new Date().getTime();

    const setActivityTime = () => {
      time = new Date().getTime();
    };

    document.querySelector('body').addEventListener('click', setActivityTime);

    const videos = document.querySelectorAll('video');
    videos.forEach((video) => {
      video.addEventListener('play', setActivityTime);
      video.addEventListener('pause', setActivityTime);
    });

    const isAnyVideoPlaying = () => {
      return [...videos].some((video) => !video.paused && !video.ended);
    };
    const isFullscreen = () => {
      return document.body.classList.contains('fullscreen-video');
    };
    const isAnyVideoPausedInFullscreen = () => {
      if (!isFullscreen()) return false;
      return [...videos].some((video) => video.paused && !video.ended);
    };

    const redirectToParent = () => {
      if (isAnyVideoPlaying()) {
        setActivityTime();
        return;
      }

      const limit = isAnyVideoPausedInFullscreen() ? 300000 : 120000;
      if (new Date().getTime() - time > limit) {
        window.location = localData.parent;
      }
    };

    setInterval(redirectToParent, 1000);
  }
} catch (e) {
  console.log(e);
}
